import { FRONT_PLANS } from 'Constants/plans';

export const ButtonsMode = {
  [FRONT_PLANS.FULL]: 'full',
  [FRONT_PLANS.PRO]: 'pro',
};
